import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash-es';
import { TimesheetBreakdownRuleService } from '../services/timesheet-breakdown-rule.service';
import { PayCategory } from '../shared/models/pay-category';
import { TimesheetBreakdownRule } from '../shared/models/timesheet-breakdown-rule';


@Component({
  selector: 'pps-pay-category-dropdown',
  template: `
    <i *ngIf="updating" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
    <select *ngIf="!updating" [compareWith]="compare" [(ngModel)]="selectedPayCategory" (change)="onChange($event, selectedPayCategory)">
      <option *ngFor="let pc of payCategories" [ngValue]="pc">{{pc.name}}</option>
    </select>
  `,
  styles: [
  ],
})
export class PayCategoryDropdownComponent implements AgRendererComponent {
  private params: any;
  updating: boolean = false;
  payCategories: PayCategory[] = [];
  selectedPayCategory: PayCategory;

  constructor() { }

  refresh(params: any): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    let parent = params.context.componentParent;
    
    this.payCategories = parent.payCategories;

    this.selectedPayCategory = params.data.payCategory;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  onChange(evt, payCategory){
    let parent = this.params.context.componentParent;
    let ruleId = this.params.data.id;
    let foundIndex = parent.rules.findIndex(x => x.id === ruleId);
    if (foundIndex === -1){
      console.log("Something wrong");
      return;
    }

    let selectedRule = parent.rules[foundIndex];
    let oldPayCategoryId = this.params.data.payCategory?.id;
    if (payCategory.id !== oldPayCategoryId){
      let rule = _.cloneDeep(selectedRule);
      rule.payCategory = _.cloneDeep(payCategory);
      this.updating = true;
      parent.updateRule(rule, "pay-category", null, null, null, () => this.updating = false);
    }
  }


  compare(a, b){
    return a&&b ? a.id === b.id : false;
  }
}